import { SHIPMENT_STATUS } from '../../../../constants/constants';
const styles = () => ({
  stepCircle: {
    color: 'white',
    width: '16px',
    height: '16px',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  notDoneStep: {
    border: '4px solid rgba(235,238,241, 1)'
  },
  notDoneColor: {
    backgroundColor: 'rgba(235,238,241, 1)'
  },
  [SHIPMENT_STATUS.WAITING_FOR_PICKUP]: {
    backgroundColor: 'rgba(0,161,251,1)'
  },
  waitingForPickupCircle: {
    border: '4px solid rgba(0,161,251,1)'
  },
  [SHIPMENT_STATUS.IN_TRANSIT]: {
    backgroundColor: 'rgba(254,176,11,1)'
  },
  inTransitCircle: {
    border: '4px solid rgba(254,176,11,1)'
  },
  [SHIPMENT_STATUS.DELIVERED]: {
    backgroundColor: 'rgba(0,195,150, 1)'
  },
  endCircles: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  lastCircle: {
    position: 'relative',
    left: '3px'
  },
  [SHIPMENT_STATUS.READY_TO_TENDER]: {
    backgroundColor: 'rgba(235,238,241, 1)'
  }
});
export default styles;
